import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, Router, ActivatedRoute } from '@angular/router';
import { Store } from '@ngxs/store';
import { SetEnvConfig, SetMiniEnvMode } from '../ngxs/actions/app-mode.state';
import { environment } from '@src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { catchError, Observable, of, switchMap, tap } from 'rxjs';
import { ApiService } from '../services/api.service';
import { HelperService } from '../services';




@Injectable({ providedIn: 'root' })
export class MiniEnvResolver implements Resolve<any> {
  constructor(private store: Store, private http: HttpClient, private apiService: ApiService, private helperService: HelperService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    // Build tenant-specific path dynamically
    const path = `/assets/tenant-assets/mini-env/${environment.miniEnvFile}`;
    let current = route;
    const allSegments: string[] = [];
    while (current.firstChild) {
      current = current.firstChild;
      allSegments.push(...current.url.map(s => s.path));
    }
    let slug = ""
    if (allSegments.length > 0) {
      slug = allSegments.join("/")
    }
    console.log(slug);
    return this.http.get<any>(path).pipe(
      switchMap((configJson: any) => {
        const routeKey = route.routeConfig?.path;

        if (slug) {
          return this.apiService.fetchAgentSlugDetails(routeKey + "/" + slug).pipe(
            tap((response) => {
              if (routeKey && configJson[routeKey]) {
                configJson[routeKey]['agent_id'] = response.body.data.referenceId;
                configJson[routeKey]['additionalPath'] = slug;
              }

              this.helperService.minienvConditions(configJson, routeKey);
            }),
            catchError((err: any) => {
              this.helperService.minienvConditions(configJson, routeKey);
              return of(configJson);
            })
          );
        } else {
          this.helperService.minienvConditions(configJson, routeKey);
          return of(configJson);
        }
      })
    );
  }
}